import { Component } from '@angular/core';
import { NavController, NavParams, PopoverController, AlertController, ToastController, ModalController, LoadingController, ViewController } from 'ionic-angular';
import { DIC } from '../../dic';
import { GN } from '../../../gn';
import { PopupPage } from '../../popup/popup';
import * as moment from 'moment';

/**
 * Generated class for the VehicledatalivePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-vehicledatalive',
  templateUrl: 'vehicledatalive.html',
})
export class VehicledatalivePage {
  obj: any

  constructor(public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public gn: GN, public popoverCtrl: PopoverController, public alertCtrl: AlertController, public toastCtrl: ToastController, public modalCtrl: ModalController, public loadingCtrl: LoadingController) {
    this.obj = this.navParams.get('obj')[0];
    if(this.obj.cntdata > 0) {
      this.obj.firstignondtinday = moment(this.obj.firstignondtinday).format(this.gn.user.TFormat)
      this.obj.diffstaystr = this.sec2str2(this.obj.diffstay)
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad VehicledatalivePage');
  }

  sec2str2(_sec) {
    if (_sec >= 0) {
      var str = '';
      var h = Math.floor(_sec / 3600);//moment.utc(_sec * 1000).format('H');
      var m = moment.utc(_sec * 1000).format('m');
      var s = moment.utc(_sec * 1000).format('s');
      if (_sec < 60) {
        str = s + this.dic.l["sec"];
      }
      else {
        if (_sec < 3600) {
          str = m + this.dic.l["min"] + ' ' + s + this.dic.l["sec"]
        }
        else {
          str = h + this.dic.l["h"] + ' ' + m + this.dic.l["min"]
        }
      }
      // console.log("sec2str2")  
      return str;
    }
    else {
      return -1;
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/mapview/vehicledatalive/vehicledatalive.ts